import React, { ReactNode } from 'react';
import { TypographyH4, TypographyP } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

interface InstructionItemProps {
    icon: ReactNode;
    header: string;
    instruction: string;
}

function InstructionItem({ icon, header, instruction }: InstructionItemProps): React.JSX.Element {
    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-row items-center gap-4">
                <div
                    className={cn(
                        'border-foreground flex size-8 shrink-0 items-center justify-center rounded-full border',
                    )}
                >
                    {icon}
                </div>
                <TypographyH4 className="text-foreground text-base">{header}</TypographyH4>
            </div>
            <TypographyP className="text-foreground">{instruction}</TypographyP>
        </div>
    );
}

export default InstructionItem;
